import useSWRMutation from 'swr/mutation';
import capsFetcher from '../../shared/capsFetcher';

const fetcher = async (config, { arg: data }) => {
  const res = await capsFetcher({
    method: 'POST',
    url: '/bank_accounts',
    data,
  });
  return res.data;
};

const useCreateBankAccount = (options) => useSWRMutation(
  '/bank_accounts',
  fetcher,
  { ...options },
);

export default useCreateBankAccount;
